import { Outlet, useLocation } from "react-router-dom";
import { Navbar } from "./Navbar";
import { Footer } from "./Footer";
import { ScrollToTop } from "./ScrollToTop";

function MainLayout() {
  const location = useLocation();

  // Hide navbar and footer during booking flow
  const isBookingFlow = location.pathname.startsWith("/book/");

  return (
    <>
      {!isBookingFlow && <Navbar />}
      <Outlet />
      {!isBookingFlow && <Footer />}
      <ScrollToTop />
    </>
  );
}

export default MainLayout;
